import { useEffect, useRef, useState } from 'react';
import { NavContent } from './Reward.styled';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import { useI18n } from '@i18n/useI18n';
import Dashboard from './Dashboard';
import AddReward from './AddReward';
import { GridWrapper } from '@components/GridCards/Common.styled';

interface IProps {}

const Redeem = (props: IProps) => {
  const i18n = useI18n();
  const { callNameSetting, adminSelection, adminSelectedStudent, clientSettings, systemSettings } = useStore();
  const [rewards, setRewards] = useState([]);
  const [logs, setLogs] = useState();
  const [nav, setNav] = useState(0);
  const [editItem, setEditItem] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  const findEditItem = (id) => {
    let item = rewards.find((r) => r.id === id);
    if (item) setEditItem(item);
    setNav(2);
  };

  let language = systemSettings.find((s) => s.APP_Setting_ID === 16);
  let localTimeZone = systemSettings.find((s) => s.APP_Setting_ID === 7);
  const getData = async () => {
    let rewards = await db.GetRewards(language.value);
    let logs = await db.GetRedeemRewards_Log(localTimeZone.value, language.value);
    setLogs(logs);
    setEditItem(null);
    setRewards(rewards);
  };

  return (
    <GridWrapper>
      <NavContent col={nav === 0}>
        {nav === 0 ? <Dashboard logs={logs} setEditItem={findEditItem} rewards={rewards} setNav={setNav} /> : null}
        {nav === 1 ? <AddReward getRewards={getData} setNav={setNav} /> : null}
        {nav === 2 ? <AddReward editItem={editItem} getRewards={getData} setNav={setNav} /> : null}
      </NavContent>
    </GridWrapper>
  );
};

export default Redeem;
